import React from "react";

export const UiTooltipItem = (props) => {
  return (
    <>
      <div className="df-tooltop-wrapper" onClick={props?.onClick}>
        <div className={props?.className}>{props?.children}</div>
      </div>
    </>
  );
};
